import "./styles/base.css";
import "./styles/navbar.css";
import "./styles/hero.css";
import "./styles/buttons.css";
import "./styles/about.css";
import "./styles/services.css";
import "./styles/forms.css";
import "./styles/footer.css";
import "./styles/pages.css";
import "./styles/responsive.css";
import "./styles/contato.css";
import Produto from "./pages/Produto";

import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/layout/Navbar";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import Footer from "./components/layout/Footer";

import Catalogo from "./pages/Catalogo";
import Promo from "./pages/Promo";
import Promocoes from "./pages/Promocoes";
import Contato from "./pages/Contato";

function Landing() {
  return (
    <>
      <Hero />
      <Services />
      <About />
    </>
  );
}

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/promo" element={<Promo />} />
        <Route path="/promocoes" element={<Promocoes />} />
        <Route path="/catalogo" element={<Catalogo />} />
        <Route path="/produto/:slug" element={<Produto />} />
        <Route path="/contato" element={<Contato />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
